import "../lib/stacktrace-js/dist/stacktrace.min";
let errors = 0;

window.onerror = async (msg, url, linNo, columnNo, error) => {
    if (++errors > 2)
        return (window.onerror = undefined);

    // eslint-disable-next-line no-undef
    const stack = window.StackTrace && await StackTrace.fromError(error);
    if (!stack?.length || !stack[0]?.lineNumber || checkErrorMsgBlacklisted(msg)) return;

    return fetch('/register-js-error', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({
            url: document.location.href,
            msg,
            stack
        })
    });
};

function checkErrorMsgBlacklisted(msg) {
    return Object.values(errorMsgs).some(errorMsg => msg.endsWith(errorMsg));
}

export const errorMsgs = {
    windowNotExist: 'Cannot access window global',
    closestListAdCoverVideo:  'listAdCoverVideo is undefined',
    categoriesNotDefined: 'Categories not defined',
    HtmlOutNotDefined: 'HTMLOUT is not defined',
    sSlideUndefined: 'TypeError: undefined is not an object (evaluating \'s.slideTo\')',
    undefinedSlideTo: 'Uncaught TypeError: Cannot read properties of undefined (reading \'slideTo\')',
    listPageNotDefined: 'Uncaught ReferenceError: listPage is not defined',
    listPageNotDefined2: 'ReferenceError: listPage is not defined',
    xBrowserNotDefined: 'Uncaught ReferenceError: xbrowser is not defined',
    nativeBackUndefined: 'Uncaught TypeError: Cannot read properties of undefined (reading \'nativeBack\')',
    type1: 'TypeError: t.toLowerCase is not a function. (In \'t.toLowerCase()\', \'t.toLowerCase\' is undefined)',
    notDefined1: 'Uncaught ReferenceError: tgetT is not defined',
    sNotDefined: 'TypeError: s is undefined',
    methodNotFound: 'Uncaught Error: Method not found',
    javaException: 'Uncaught Error: Java exception was raised during method invocation',
    cantFindVarListPage: 'ReferenceError: Can\'t find variable: listPage',
    displayModalAdUndefined: 'Uncaught TypeError: Cannot read properties of undefined (reading \'displayModalAd\')',
    typeErrorMetaPropOg: 'TypeError: null is not an object (evaluating \'document.querySelector("meta[property=\'og:type\']").content\')',
    undefinedListPageStories: 'TypeError: undefined is not an object (evaluating \'window.listPage.stories\')',
    cantFindVariableHomePage: 'ReferenceError: Can\'t find variable: homePage',
    jQueryNotDefined: 'ReferenceError: jQuery is not defined',
    bootstrap5error: 'Uncaught TypeError: Cannot read properties of undefined (reading \'parentNode\')',
    undefinedStoriesContextualMenu: 'Uncaught TypeError: Cannot read properties of undefined (reading \'storiesSlider\')',
    requiredIsNotDefined: 'Uncaught ReferenceError: require is not defined',
    windowAndroidShowSource: 'Uncaught TypeError: window.android.showSource is not a function',
    messageHandlersNotDefined: 'TypeError: undefined is not an object (evaluating \'window.webkit.messageHandlers\')',
    undefinedListPageModalAdDisplayModalAdFavorites: 'TypeError: undefined is not an object (evaluating \'listPage.modalAd.displayModalAd\')',
    undefinedStories: 'Uncaught TypeError: Cannot read properties of undefined (reading \'stories\')',
    pemlmekccdbjmfeehbmbehbjpcnppcefExtensionInjectJs: 'Message: Uncaught TypeError: Unable to fetch chrome-extension://pemlmekccdbjmfeehbmbehbjpcnppcef/scriptJs/inject/inject.js - see network log for details.\nFailed to fetch',
    desktopToMobileUndefinedFichaFnSettingsModalHide: 'TypeError: undefined is not an object (evaluating \'window.fichaFn.settingsModal.hide\')',
    egjidjbpglichdcondbcbdnbeeppgdphExtensionJs: 'Uncaught TypeError: Cannot read from private field',
    ffljdddodmkedhkcjhpmdajhjdbkogkeDataLayerJsExtension: 'Uncaught TypeError: Cannot read properties of undefined (reading \'consoleLog\')',
    referenceErrorAutofillCallbackHandler: 'ReferenceError: Can\'t find variable: _AutofillCallbackHandler',
    securityErrorLocalStorage: 'Uncaught SecurityError: Failed to read the \'localStorage\' property from \'Window\': Access is denied for this document.',
    favoritesListPageModalAdDisplayModalAdNotDefined: 'TypeError: undefined is not an object (evaluating \'listPage.modalAd.displayModalAd\')',
    homePageIsNotDefined: 'Uncaught ReferenceError: homePage is not defined',
    dcmdiknbnpjcbecpfpipeadobeldbijhExtensionJs: 'Uncaught TypeError: Cannot read properties of undefined (reading \'onMessage\')',
    gmo: 'ReferenceError: Can\'t find variable: gmo',
    i18nImprovement: 'Uncaught TypeError: Cannot read properties of undefined (reading \'Relevancia\')'
};
